import {
  Box,
  Button,
  Menu,
  ToggleButton as MUIToggleButton,
  ToggleButtonGroup as MUIToggleButtonGroup,
  Tooltip,
  styled,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';

import TransparentImage from '../../assets/images/transparent.jpg';

export const DownloadButton = styled(Button)(({theme}) => ({
  marginRight: theme.spacing(1),
}));

export const FooterSwatch = ({
  gradient = false,
  transparent = false,
  ...props
}) => (
  <Box
    {...props}
    sx={[
      {
        width: 18,
        height: 18,
        borderRadius: 1,

        background: theme =>
          gradient
            ? `linear-gradient(to top, black, ${theme.vars.palette.primary.main})`
            : '',

        backgroundImage: transparent ? `url(${TransparentImage})` : '',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  />
);

FooterSwatch.propTypes = {
  gradient: PropTypes.bool,
  transparent: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export const ToggleButton = React.forwardRef(
  ({sx, tooltipTitle, ...props}, ref) => (
    <Tooltip title={tooltipTitle} placement="bottom">
      <MUIToggleButton
        ref={ref}
        size="small"
        color="primary"
        sx={[
          {
            '&:not(:first-of-type)': {ml: 1},
            border: 'none',
            '&.MuiToggleButton-root': {
              border: 'none',
            },
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...props}
      />
    </Tooltip>
  )
);

ToggleButton.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  tooltipTitle: PropTypes.string,
};

export const SnapshotMenuButton = ({
  label,
  children,
  tooltipTitle,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <React.Fragment>
      <ToggleButton
        color="standard"
        tooltipTitle={tooltipTitle}
        value={tooltipTitle}
        onClick={handleClick}
        selected={Boolean(anchorEl)}
        sx={{
          minWidth: 40,
          width: 40,
          height: 40,
        }}
        {...props}
      >
        {label}
      </ToggleButton>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {marginTop: 0.5},
          },
        }}
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        {children}
      </Menu>
    </React.Fragment>
  );
};

SnapshotMenuButton.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node,
  tooltipTitle: PropTypes.string,
};

export const ToggleButtonGroup = props => (
  <MUIToggleButtonGroup
    size="small"
    exclusive
    sx={{
      paddingX: 1,
      '& .MuiToggleButtonGroup-grouped': {
        margin: 0.5,
        '&:not(:first-of-type)': {
          borderRadius: 1,
        },
        '&:first-of-type': {
          borderRadius: 1,
        },
      },
    }}
    {...props}
  />
);
